import {getDate} from '../../../../../../@casino/lib/getDate';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'event_date', label: 'Дата события'},
    { id: 'login', label: 'Логин'},
    { id: 'groups', label: 'Группа'},
    { id: 'jackpot', label: 'Джекпот'},
    { id: 'amount', label: 'Сумма'}
];

const getRows = (list) => {
    return list.data.map((item) => {
        return {
            id: item.id,
            event_date: getDate(+item.event_date),
            login: parseLogin(item.login),
            groups: item.groups,
            jackpot: item.jackpot,
            amount: new Intl.NumberFormat('ru-RU').format(item.amount) + '₽'
        }
    })
} 

export {
    columns,
    getRows
}